import Autolinker from 'autolinker'

export const autoLink = (str: string) => {
  // NOTE: 前後に CJK 文字がある場合を中心にリンクがおかしくなる。
  //       ref. https://github.com/gregjacobs/Autolinker.js/issues/394#issuecomment-1465697645
  //       ref. https://www.notion.so/889e148deadd408eb0fd398cd1ef99fc?pvs=4
  //       暫定的な修正として、リンクらしき文字列の前に必ずスペースが入るようにする
  const adhocFixedStr = str.replace(/([^\s])(https?:\/\/)/g, '$1 $2')

  return Autolinker.link(adhocFixedStr, {
    stripPrefix: false,
    stripTrailingSlash: false,
    className: 'autoliner-link',
  })
}
